import { gql } from '@apollo/client';

export const GET_ALL_USERS = gql`
  query getAdminsUsers(
    $amount: Float!
    $offset: Float!
    $sortBy: SortByField
    $companyId: String
    $email: String
    $roles: [Roles!]
  ) {
    searchUser(
      input: {
        amount: $amount
        offset: $offset
        searchOptions: { companyId: $companyId, email: $email, roles: $roles }
        sortBy: $sortBy
      }
    ) {
      count
      users {
        ...CompanyUserFields
        company {
          ...CompanyFields
        }
      }
    }
  }
`;

export const GET_ACTIVE_USERS_INFO = gql`
  query getAdminsUsersInfo {
    getAdminUsersInfo {
      availableUserCount
      allUsersCSV
    }
  }
`;
